import { Avatar, Box, EnhancedDimension, Text } from '@factorialco/deprecated-design-system'
import { SubprojectsDataTableSubprojectsPanelEmployeeCardFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { Amount } from 'modules/project_management/components/Amount'
import { formatProjectHours } from 'modules/project_management/lib/formatHours'

interface IEmployeeCardProps {
  employee: SubprojectsDataTableSubprojectsPanelEmployeeCardFragment
  imputedMinutes: number
  laborCostCents: number | null | undefined
  laborCostCurrency: string
  canSeeLaborCosts: boolean
}

const EmployeeCard = ({
  employee,
  imputedMinutes,
  laborCostCents,
  laborCostCurrency,
  canSeeLaborCosts,
}: IEmployeeCardProps) => {
  if (!employee) return null

  const setFullNameWidth = (): EnhancedDimension => {
    if (imputedMinutes > 6000 || employee.fullName.length > 20) return 's140'
    return 's200'
  }

  return (
    <Box
      flexDirection="row"
      padding="s16"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
    >
      <Box flexDirection="column" width="full" gap="s6">
        <Box flexDirection="row">
          <Avatar size="s24" url={buildUrl(employee.access.avatar)} label={employee.fullName} />
          <Box paddingLeft="s8" maxWidth={setFullNameWidth()}>
            <Text size="300" weight="medium" ellipsis>
              {employee.fullName}
            </Text>
          </Box>
        </Box>

        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text size="200" weight="medium">
            {i18n.t('project_management.subprojects.details.worked_hours')}
          </Text>
          <Box flexNoShrink alignItems="flexEnd">
            <Text size="200" weight="medium" color="grey800">
              {formatProjectHours(imputedMinutes)}
            </Text>
          </Box>
        </Box>

        {canSeeLaborCosts && (
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text size="200" weight="semibold" color="grey1000">
              {i18n.t('project_management.subprojects.details.cost')}
            </Text>
            <Box flexNoShrink alignItems="flexEnd">
              <Amount
                amount={laborCostCents}
                currency={laborCostCurrency}
                size="200"
                weight="semibold"
                color="grey1000"
              />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default EmployeeCard
